import { useContext } from "react";
import appStyles from "../../../App.module.css";
import { BusinessTravelContext } from "../../BusinessTravel";
import { businessTravelDocs } from "../../config/bt-constants";
import { IBusinessTravelContext } from "../../config/interfaces";

const CoveredMoreThan250TripsModal = () => {
  const { version } = useContext(BusinessTravelContext) as IBusinessTravelContext;
  return (
    <div className={`${appStyles.btModalDetailWrap}`}>
      <h2 className={appStyles.btBenefitSummaryTitle}>We need a few more details</h2>
      <p className={appStyles.btModalDetail}>
        For 250 or more estimated annual trips, please apply for a custom quote by clicking below. We'll be in touch
        with you within 2 business days of your application.
      </p>
      <button
        className={`${appStyles.btModalBtn} ${appStyles.btModalCustomQuoteBtn}`}
        onClick={() => window.open(businessTravelDocs.customQuote, "_blank", "noopener")}
      >
        Apply for custom Quote
      </button>
    </div>
  );
};

export default CoveredMoreThan250TripsModal;
